export default "__VITE_PUBLIC_ASSET__4d2b5576__"